/* model-filter:
 *
 * Filter models by name
 *
 * Author: Niels Giesen
 * Copyright 2013, 2016 Berkeley Bridge
 *
 */
import { escapeRegexpString } from "$json/lib/escape.js";
(function ($, doc) {
  var $filter;

  $(function () {
    var $doc = $(doc);
    $filter = $("#bb-p-model-filter");

    $doc
      .on("bb:postHandleData", filter)
      .on("keyup", "#bb-p-model-filter", filter)
      .on("click touchstart", "#bb-p-model-filter-clear", clear);

    $filter.on("keydown", function (ev) {
      if (ev.key === "Enter") {
        var $filtered = $(".bb-model:visible");
        if ($filtered.length === 1)
          $filtered.find(".bb-newcase").addBack().last().trigger("click");
      }
    });
  });
  function filter() {
    $("#bb-p-model-filter-nomatches").hide();
    var val = ($filter.val() || "").trim();
    var hasmatch = false;

    if (val.length >= 3) {
      let re;
      try {
        // Safe initialization: if the user types malformed regex, it won't crash the script
        // eslint-disable-next-line security/detect-non-literal-regexp -- We trust this
        re = new RegExp(val, "i");
      } catch (e) {
        // Fallback: If regex compilation fails, treat the input as a literal string match instead
        const escapedVal = escapeRegexpString(val);
        // eslint-disable-next-line security/detect-non-literal-regexp -- any wildcards are now literal
        re = new RegExp(escapedVal, "i");
      }

      $(".bb-model").each(function () {
        var $this = $(this);
        // Find the description in the child or -- when absent -- as the text content itself
        var text = $this.find(".bb-model-name").text() || $this.text();

        // Cleaned up: removed redundant 'val.length < 3' check since parent block guarantees it
        var ismatch = re.test(text);
        hasmatch = hasmatch || ismatch;
        $this.toggle(ismatch);
      });
    } else {
      // Ensure that if input falls below 3 characters, everything is shown again
      $(".bb-model").show();
      hasmatch = true;
    }

    $filter.toggleClass("bb-p-model-filter-has-no-match", !hasmatch);
    if (!hasmatch) {
      $(".bb-model").show();
    }
  }

  function clear() {
    $filter.val("").trigger("keyup").trigger("focus");
  }
})(jQuery, document);
